import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'
import MenuPersonalizationList from 'pages/Commercial/MenuPersonalization/List'

export const MenuPersonalizationRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route
      path="/commercial/menuPersonalization"
      component={MenuPersonalizationList}
      exact
    />
  </CustomSwitch>
)
